import { RedirectOutput } from '../../shared/mycicero-web-api/shared/redirect-output.model'

export interface LoginRedirect {
  redirectUrl: string
}

export const mapRedirectOutput = (redirectOutput: RedirectOutput): LoginRedirect => {
  return {
    redirectUrl: redirectOutput.UrlRedirect,
  }
}
